export default "__VITE_ASSET__EQGFY2uZ__"